import { render, staticRenderFns } from "./CompanyDepartmentFilter.vue?vue&type=template&id=06795f13&"
import script from "./CompanyDepartmentFilter.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports